var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddConnector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 33.5833C27.25 28.9791 21.6542 25.2499 14.75 25.2499C7.84583 25.2499 2.25 28.9791 2.25 33.5833M35.5833 27.3333V21.0833M35.5833 21.0833V14.8333M35.5833 21.0833H29.3333M35.5833 21.0833H41.8333M14.75 18.9999C12.5399 18.9999 10.4202 18.1219 8.85744 16.5591C7.29464 14.9963 6.41667 12.8767 6.41667 10.6666C6.41667 8.45645 7.29464 6.33683 8.85744 4.77403C10.4202 3.21123 12.5399 2.33325 14.75 2.33325C16.9601 2.33325 19.0798 3.21123 20.6426 4.77403C22.2054 6.33683 23.0833 8.45645 23.0833 10.6666C23.0833 12.8767 22.2054 14.9963 20.6426 16.5591C19.0798 18.1219 16.9601 18.9999 14.75 18.9999Z",
    stroke: "#CE1111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddConnector);
export default __webpack_public_path__ + "static/media/add_connector.4e2862fab29e736b506908a50f9538bf.svg";
export { ForwardRef as ReactComponent };